  <template>
    <div>
      <button class="btn btn-green" @click="showModal">+ New subgroup</button>

      <!-- Modal -->
      <div class="modal fade" ref="staffMemberModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">New subgroup</h5>
              <button type="button" class="close" @click="hideModal" aria-label="Close">
                <span aria-hidden="true">X</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row d-flex align-items-stretch">
                <!-- Subgroup details Card -->
                <div class="col-md-6 d-flex">
                  <div class="card flex-grow-1">
                    <div class="card-body">
                      <div class="form-group">
                        <label for="subgroup-name">Subgroup name</label>
                        <input 
                          type="text" 
                          id="subgroup-name" 
                          class="form-control" 
                          v-model="form.name"
                        />
                      </div>
                      <div class="form-group">
                        <label for="subgroup-commission">Subgroup commission</label>
                        <div class="input-group">
                          <input 
                            type="text" 
                            id="subgroup-commission" 
                            class="form-control" 
                            v-model="form.commission"
                            @blur="validateCommission" 
                          />
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- History Card -->
                <div class="col-md-6 d-flex">
                  <div class="card flex-grow-1">
                    <div class="card-body">
                      <div class="form-group row">
                        <div class="col-12">
                            <h5 class="section-title">History</h5>
                            <div class="col-12">
                                <label for="created" class="form-label">Created</label>
                                <input type="datetime" class="form-control" disabled />
                            </div>
                            <div class="col-12">
                                <label for="updated" class="form-label">Updated</label>
                                <input type="datetime" class="form-control" disabled />
                            </div>
                            <label for="notes" class="form-label">Notes</label>
                            <textarea class="form-control" v-model="form.notes" rows="4"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-green btn-ok" :disabled="!isFormValid" @click="submitForm">Save</button>
              <button class="btn btn-cancel" @click="hideModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script setup>
  import { ref, computed } from 'vue';
  import { Modal } from 'bootstrap';
  import { useSubgroupStore } from '@/store/admin/subgroup';
  import Swal from 'sweetalert2';

  const subgroupStore = useSubgroupStore();

  const form = ref({
    name: '',
    commission: '',
    notes: '',
    created_at: '',
    updated_at: '',
  });

  const staffMemberModal = ref(null);
  let modalInstance = null;

  // 驗證 commission 格式
  const isCommissionValid = ref(true);

  const showModal = () => {
    form.value = {
      name: '',
      commission: '',
      notes: '',
      created_at: new Date().toISOString().slice(0, 16),
      updated_at: new Date().toISOString().slice(0, 16),
    };
    if (!modalInstance) {
      modalInstance = new Modal(staffMemberModal.value);
    }
    modalInstance.show();
  };

  const hideModal = () => {
    if (modalInstance) {
      modalInstance.hide();
    }
  };

  // 驗證 commission 格式是否正確
  const validateCommission = () => {
    const commission = form.value.commission;
    const commissionValue = parseFloat(commission);

    // 允許小數點後最多兩位且不能超過 100
    if (/^\d+(\.\d{1,2})?$/.test(commission) && commissionValue <= 100) {
      isCommissionValid.value = true;
    } else {
      isCommissionValid.value = false;
      Swal.fire({
        icon: 'error',
        title: 'Invalid commission!',
        text: 'Commission must be a valid number between 0 and 100, with up to two decimal places.',
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  // 檢查表單是否有效
  const isFormValid = computed(() => {
    return form.value.name && isCommissionValid.value;
  });

  const submitForm = async () => {
    if (!isFormValid.value) {
      Swal.fire({
        icon: 'error',
        title: 'Please fill in all required fields.',
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    const payload = {
      name: form.value.name,
      commission: form.value.commission,
      notes: form.value.notes,
    };

    try {
      await subgroupStore.createSubgroup(payload);
      hideModal();

      // 重置表單
      form.value = {
        name: '',
        commission: '',
        notes: '',
        created_at: '',
        updated_at: '',
      };
    } catch (error) {
      console.error('Error creating subgroup:', error);
    }
  };
  </script>

  <style scoped>
  .btn-green {
    background: rgba(0, 201, 98, 1);
    color: black;
    border: none;
    width: 208.83px;
    height: 46px;
    border-radius: 30px;
    padding: 10px, 32px, 10px, 32px  ;
  }
  
  .btn-green:hover {
    background-color: #00b452;
  }
  
  .btn-ok{
    width: 150px;
  }

  .btn-cancel {
    background-color: #fff;
    color: black;
    width: 150px;
    height: 46px;
    border-radius: 30px;
    border: 1px solid #8476f4;
    padding: 10px, 32px, 10px, 32px  ;
  }
  
  .btn-cancel:hover {
    background-color: #e6e6ff;
  }
  
  .modal-content {
    border-radius: 10px;
    padding: 20px;
  }
  
  .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-footer {
    border-top: 1px solid #dee2e6;
    background-color: #f8f9fa;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  
  .card-header {
    border-bottom: 1px solid #dee2e6;
    font-weight: bold;
    background-color: #d9dde3;
  }
  
  .card{
    background-color: #d9dde3;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-control {
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #ced4da;
  }
  
  .close {
    color: #333;
    opacity: 1;
    font-size: 20px;
    padding: 0;
    background: none;
    border: none;
  }
  
  .close:hover {
    color: #000;
  }
  
  /* 使用 flexbox 來讓卡片等高 */
  .row.d-flex {
    display: flex;
  }
  
  .col-md-6.d-flex {
    display: flex;
    flex-direction: column;
  }
  
  .card.flex-grow-1 {
    flex-grow: 1;
  }
  
  .align-items-stretch {
    align-items: stretch;
  }
  </style>
  